/**
 * answer-proxy.ts
 * Copyright (c) 2017, My Coverage Plan, Inc.
 * All rights reserved.
 */

// import { FactoryProvider, Injectable, OpaqueToken } from "@angular/core";
import { Observable } from "rxjs/Rx";
import { TypedDataHolder } from "../../common/data/typed-data";
import { Message } from "../../server/messages/index";
import { IntakeStep } from "../structure";

/**
 * An {@link AnswerProxy} is an interface that provides a method of submitting
 * answers to {@link IntakeStep}s or generic {@link TypedDataHolder}s. It is
 * intended to be provided by intake form components to their children, so that
 * descendant components can submit through the component's mechanisms rather
 * than weaving through a centralized service.
 */
export abstract class AnswerProxy
{
    /**
     * Submit a single answer to the server (or another consumer)
     */
    public abstract submitAnswer (step : TypedDataHolder, e? : Event)
        : Observable<Message>;

    public abstract submitRaw (step : string, value : any)
        : Observable<Message>;

    /**
     * Submit a batch of answers as a single atomic operation
     */
    public abstract submitMultiple (steps : TypedDataHolder[], e? : Event[])
        : Observable<Message>;
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/algorithms/management/answer-proxy.ts